// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation DeleteShipmentItemMutation($input: DeleteShipmentItemInput!) {
    deleteShipmentItem(input: $input) {
      deletedId
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, {
      ...options,
    });
  },
};
